// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3XFNV","footer":"Form_footer__pEVtK"};